import moment from 'moment/moment'

import { DataType } from '../types/DataType'
import { ConstructorArgs } from '../types/models'
import { BaseRecord } from './BaseRecord'
import { FKType } from './SQLBuilder'

type GoalConstructorArgs = ConstructorArgs<() => Goal>

export enum GOAL {
    GOAL_REGISTERED,
    GOAL_VERIFIED,
    GOAL_TEXTED_CLIENTS,
    GOAL_MPB,
    GOAL_BOOKED_ONLINE,
    GOAL_POWER_MAU,
    GOAL_ACTIVE_POSTER,
    GOAL_WEEK_MPB,
    GOAL_FORTNIGHT_MPB,
    GOAL_MONTH_RISING,
    GOAL_MONTH_VIP,
    GOAL_BRONZE_VIP,
    GOAL_SILVER_VIP,
    GOAL_GOLD_VIP,
    GOAL_DIAMOND_VIP,
}

export class Goal extends BaseRecord {
    readonly recordType = 'goal'

    readonly name?: string
    readonly tip?: string
    readonly alert?: string
    readonly caption?: string
    readonly seqnum?: number
    readonly lastModifiedDate?: moment.Moment

    constructor(data?: Partial<GoalConstructorArgs>) {
        super(data)
        if (!data) {
            return
        }

        this.name = data.name ?? undefined
        this.tip = data.tip ?? undefined
        this.alert = data.alert ?? undefined
        this.caption = data.caption ?? undefined
        this.seqnum = this.propertyFromIntArg(data.seqnum)
        this.lastModifiedDate = this.propertyFromTimestampArg(data.last_modified_date)
    }

    clone(overrides?: Partial<GoalConstructorArgs>): Goal {
        return new Goal({ ...this.serializeForClone(), ...overrides })
    }

    /**
     * Return helper icon used to display next to feature name on Enable features screen
     * return icon
     */
    get goal(): GOAL | undefined {
        switch (this.id) {
            case 'registered':
                return GOAL.GOAL_REGISTERED
            case 'verified':
                return GOAL.GOAL_VERIFIED
            case 'texted_clients':
                return GOAL.GOAL_TEXTED_CLIENTS
            case 'mpb':
                return GOAL.GOAL_MPB
            case 'booked_online':
                return GOAL.GOAL_BOOKED_ONLINE
            case 'power_mau':
                return GOAL.GOAL_POWER_MAU
            case 'active_poster':
                return GOAL.GOAL_ACTIVE_POSTER
            case 'week_mpb':
                return GOAL.GOAL_WEEK_MPB
            case 'fortnight_mpb':
                return GOAL.GOAL_FORTNIGHT_MPB
            case 'month_rising':
                return GOAL.GOAL_MONTH_RISING
            case 'month_vip':
                return GOAL.GOAL_MONTH_VIP
            case 'bronze_vip':
                return GOAL.GOAL_BRONZE_VIP
            case 'silver_vip':
                return GOAL.GOAL_SILVER_VIP
            case 'gold_vip':
                return GOAL.GOAL_GOLD_VIP
            case 'diamond_vip':
                return GOAL.GOAL_DIAMOND_VIP
        }
        return undefined
    }

    static dataType(): DataType {
        return 'goals'
    }

    static fk: FKType = {}
}
